/**
 * Spanish (es) mappings for UpgradeNotice
 */

export const upgradeNoticeES = {
  // Cost banner
  "Just $1.99 gets you another analysis!": "¡Solo $1.99 para otro análisis!",

  // New Modal Copy
  "Limit Hit": "Límite Alcanzado",
  "body_text": "Has alcanzado el límite de jugadas gratis de hoy.\nTu saldo se reiniciará en {hoursUntilReset} horas.",
  "offer_section": "Solo $1.99 → desbloquea 2x más análisis de IA o 3x QuickPicks\n¡Usa StarCoins para seguir jugando!\nHazte Pro para 40x chats de IA al día.",
  "Your call. Your game.": "Tu decisión. Tu juego.",

  // Old Titles (kept for backwards compatibility)
  "Daily Message Limit Reached": "Límite Diario de Mensajes Alcanzado",
  "Message Limit Reached": "Límite de Mensajes Alcanzado",

  // Descriptions - these need special handling due to dynamic content
  "daily_limit_description_pro": "Has usado todos tus {dailyLimit} mensajes diarios pro. ¡Haz clic en el ícono StarCoin en tu Ventana de Chat para más Poder!",
  "daily_limit_description_basic": "Has alcanzado tu límite de {dailyLimit} mensajes.",

  // Time messages
  "Messages reset in": "Mensajes se reinician en",
  "hours": "horas",

  // Buttons
  "Ask Another Question for 5 Star Coins": "Haz Otra Pregunta por 5 Star Coins",
  "Buy Star Coins to Continue": "Comprar Star Coins para Continuar",
  "Use Star Coins to Continue": "Usar Star Coins para Continuar",
  "Buy Star Coins": "Comprar Star Coins",
  "Continue with Star Coins": "Continuar con Star Coins",
  "Upgrade to Pro": "Actualizar a Pro",
  "Got it": "Entendido",
  "Continue in Basic": "Continuar en Básico",

  // Info messages
  "5 Star Coins per question • No subscription needed": "5 Star Coins por pregunta • Sin suscripción necesaria",
  "5 Star Coins per question • Works without a subscription!": "5 Star Coins por pregunta • ¡Funciona sin suscripción!",
  "Pro users get 40 AI insights daily • 5 Star Coins per extra question": "Usuarios Pro reciben 40 análisis de IA diarios • 5 Star Coins por pregunta extra",
  "Pro: 40 daily AI insights • Star Coins: 5 per question": "Pro: 40 análisis de IA diarios • Star Coins: 5 por pregunta",
  "2 Star Coins per message • No subscription needed": "2 Star Coins por mensaje • Sin suscripción necesaria",
  "Star Coins work without a subscription!": "¡Star Coins funcionan sin suscripción!",
  "Pro users get 40 AI insights daily • Star Coins for extra usage": "Usuarios Pro reciben 40 análisis de IA diarios • Star Coins para uso extra",
  "Pro: 40 daily AI insights • Star Coins: Pay per use": "Pro: 40 análisis de IA diarios • Star Coins: Paga por uso",

  // Aria labels
  "Close": "Cerrar"
};
